﻿/*-------------------------------------------------------
'   @module: ART - Accordion
'---------------------------------------------------------*/

export class ARTAccordion {
    constructor(wrapperSelector = '.accordion',
        tabSelector = '.accordion-tab',
        expandSelector = `[data-art-action="expand"]`,
        contentSelector = ".accordion-content") {
        // selectors
        this.wrapperSelector = wrapperSelector;
        this.tabSelector = tabSelector;
        this.expandSelector = expandSelector;
        this.contentSelector = contentSelector;

        this.wrapper = document.querySelectorAll(this.wrapperSelector);
        this.attachEventListener();
    }

    /**
     * Attach event listeners.
     */
    attachEventListener() {
        Array.from(this.wrapper).forEach(wrapper => {
            wrapper.addEventListener('click', e => {
                if(e.target.closest(this.tabSelector)) {
                    this.toggleTab(e);
                }
            });
        });
    }

    /**
     * Toggle tab of clicked element.
     * @param {Object} e clicked element
     */
    toggleTab(e) {
        const tab = e.target.closest(this.tabSelector);
        if (tab && !e.target.closest(this.contentSelector)) {
            tab.classList.toggle('is-open');
        }
    }
}